module.exports = __webpack_public_path__ + "img/trade_and_cashback_03.png";